import React from 'react';
import { Box, Typography } from '@mui/material';
import styles from './itemStyles';

export default React.forwardRef(({ detail: { Icon, ...detail } }, ref) => {
  return (
    <Box sx={styles.root}>
      <Typography variant="desktopP2">{detail.title}</Typography>
      <Box ref={ref} sx={styles.detailsBox}>
        <Box className="icon" sx={styles.iconBox}>
          <Icon sx={styles.icon} />
        </Box>
        <Box className="text" sx={styles.textBox}>
          <Typography
            variant="desktopH3"
            color="kit.text.main"
            sx={{ whiteSpace: 'pre-wrap' }}
          >
            {detail.info}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
});
